<mat-toolbar class="bg-beige-tricon flex justify-between">
    Remove Applicant
    <button class="pl-4" mat-dialog-close>&times;</button>
</mat-toolbar>

<mat-dialog-content class="mt-2">
    <p>Are you sure you want to remove {{data.removedPerson}} from your application?</p>
</mat-dialog-content>

<mat-dialog-actions class="w-2/3 flex justify-between mx-auto my-2">
    <div class="flex">
        <button mat-flat-button class="flex items-center justify-center" color="primary" mat-dialog-close mat-dialog-close="confirmRemove">YES</button>
    </div>
    <div class="flex">
        <button mat-flat-button class="flex items-center justify-center" color="primary" mat-dialog-close mat-dialog-close="cancelRemove">NO</button>
    </div>
</mat-dialog-actions>